module.exports = __webpack_public_path__ + "static/media/caireferral.4b6fc161.svg";